import { ReactComponent as Collapse } from "./svg/icon-collapse.svg";

export const IconCollapse = () => <Collapse />;
